export default __webpack_public_path__ + "static/media/gmail-icon.950d13d1.svg";